const isNullable = (value) => {
    return value === null || value === undefined;
};
const isNotNullable = (value) => {
    return !isNullable(value);
};
const isUndefined = (value) => {
    return value === undefined;
};
const isNotUndefined = (value) => {
    return !isUndefined(value);
};
const isArray = (value) => {
    return Array.isArray(value);
};
const isObject = (value) => {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
export const Value = {
    isNullable,
    isNotNullable,
    isUndefined,
    isNotUndefined,
    isArray,
    isObject,
};
//# sourceMappingURL=Value.js.map